<template>
  <div class="ordersucceed">
    <!--<van-nav-bar title="订单成功" fixed left-arrow @click-left="goBack" @click-right="onClickRight">-->

    <!--</van-nav-bar>-->
    <div style="padding-top: 0" class="van-content">
      <div class="title theme-bg">
        <i class="van-icon iconfont icon-biaodanchenggongtishi col-fff"></i><span>恭喜您兑换成功</span>
        <p class="ft12" style="color: #fff;padding: 5px 15px">感谢您的支持，我们会尽快为您安排发货，若节假日订单顺延工作日处理,祝您兑换愉快！</p>
      </div>
      <van-cell-group>
        <van-cell>
          <template slot="title">
            <span class="van-cell-text">下单时间：{{ datas.add_time }}</span>
          </template>
        </van-cell>
        <van-cell>
          <template slot="title">
            <span class="van-cell-text">订单编号：{{ datas.order_sn }}</span>
          </template>
        </van-cell>
        <van-cell>
          <template slot="title">
            <span class="van-cell-text">支付方式：
            <span v-show="datas.is_money == 1">积分+现金</span>
            <span v-if="datas.is_pay == 1&&datas.order_type == 1">积分抽奖</span>
            <span v-else-if="datas.is_pay == 1">积分</span>
            </span>
          </template>
        </van-cell>
        <van-cell>
          <template slot="title">
            <span class="van-cell-text">支付状态：已支付</span>
          </template>
        </van-cell>
        <van-cell>
          <template slot="title">
            <span class="van-cell-text">支付总额：{{ datas.total }}{{ configData.integral_name }} </span>
          </template>
        </van-cell>
        <van-cell style="padding-bottom: 20px;padding-top: 15px;">
          <router-link :to="{path:'/user/myorder/order',query:{id:datas.id}}" class="float-right"><van-button size="small" class="theme-bd theme-col">查看订单</van-button></router-link>
        </van-cell>
      </van-cell-group>
    </div>
    <footer-nav></footer-nav>
  </div>
</template>

<script>
  import FooterNav from '@/components/footernav'
  export default {
    name: "ordersucceed",
    components: {
      FooterNav
    },
    props:['userConfig','configData'],
    data () {
      return {
        orderID:this.$route.query.orderId,
        datas:'',
      }
    },
    methods:{
      goBack: function () {
        history.back(-1);
      },
      onClickRight: function () {
        console.log('按钮');
      },
      getDatas:function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.get('WebApi/JifenOrder/CreatOrder/creatSuccess', {token:isUser,order_sn:this.orderID}, res => {
          console.log(res.data.data);
          this.datas = res.data.data[0]
        })
      },
    },
    mounted () {
      this.getDatas()
    },
  }
</script>

<style lang="less" scoped>
  .ordersucceed{
    .title{
      .van-icon{
        font-size: 3rem;
      }
    }
    .van-cell-group{
      padding-top: 10px;
      background: #fff;
    }
    .van-cell{
      padding-top: 5px;
      padding-bottom: 5px;
    }
    .van-cell:not(:last-child)::after{
      border-bottom-width:0;
    }
    .title{
      text-align: center;
      padding: 35px 0;
      font-size: 2rem;
    }
    .title .van-icon{
      vertical-align: middle;
      margin-right: 5px;
    }
    .title span{
      vertical-align: middle;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/affirmorder/ordersucceed.vue